import { requestShowListing } from '../containers/EditListingPage/EditListingPage.duck';
import { addMarketplaceEntities } from '../ducks/marketplaceData.duck';
import { storableError } from '../util/errors';

// Action Types
export const UPDATE_IMAGES_REQUEST = 'app/global/UPDATE_IMAGES_REQUEST';
export const UPDATE_IMAGES_SUCCESS = 'app/global/UPDATE_IMAGES_SUCCESS';
export const UPDATE_IMAGES_ERROR = 'app/global/UPDATE_IMAGES_ERROR';

export const UPLOAD_IMAGE_REQUEST = 'app/global/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'app/global/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'app/global/UPLOAD_IMAGE_ERROR';

// Initial State
const initialState = {
  updateInProgress: false,
  updateError: null,
  uploadInProgress: false,
  uploadError: null,
};

// Reducer
export default function globalReducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_IMAGES_REQUEST:
      return { ...state, updateInProgress: true, updateError: null };
    case UPDATE_IMAGES_SUCCESS:
      return { ...state, updateInProgress: false };
    case UPDATE_IMAGES_ERROR:
      return { ...state, updateInProgress: false, updateError: action.payload };

    case UPLOAD_IMAGE_REQUEST:
      return { ...state, uploadInProgress: true, uploadError: null };
    case UPLOAD_IMAGE_SUCCESS:
      return { ...state, uploadInProgress: false };
    case UPLOAD_IMAGE_ERROR:
      return { ...state, uploadInProgress: false, uploadError: action.payload };
    default:
      return state;
  }
}

// Action Creators
export const updateImagesRequest = data => ({
  type: UPDATE_IMAGES_REQUEST,
  payload: data,
});

export const updateImagesSuccess = response => ({
  type: UPDATE_IMAGES_SUCCESS,
  payload: response,
});

export const updateImagesError = error => ({
  type: UPDATE_IMAGES_ERROR,
  payload: error,
  error: true,
});

export const uploadImageRequest = data => ({
  type: UPLOAD_IMAGE_REQUEST,
  payload: data,
});

export const uploadImageSuccess = response => ({
  type: UPLOAD_IMAGE_SUCCESS,
  payload: response,
});

export const uploadImageError = error => ({
  type: UPLOAD_IMAGE_ERROR,
  payload: error,
  error: true,
});

// Selectors
export const imagesUpdateInProgress = state => {
  return state.ListingImages ? state.ListingImages.updateInProgress : false;
};

export const imagesUpdateError = state => {
  return state.ListingImages ? state.ListingImages.updateError : null;
};

export const imagesUploadInProgress = state => {
  return state.ListingImages ? state.ListingImages.uploadInProgress : false;
};

// Thunk
export function quickUpdateImages(data) {
  return async (dispatch, getState, sdk) => {
    dispatch(updateImagesRequest(data));
    const { isProfilePictures, config, ...rest } = data;
    try {
      if (!data?.id) return;
      const response = await sdk.ownListings.update(rest);
      dispatch(updateImagesSuccess(response));
      dispatch(addMarketplaceEntities(response));
      if (isProfilePictures) {
        dispatch(requestShowListing({ id: data?.id }, config));
      }

      return response;
    } catch (e) {
      const error = storableError(e);
      dispatch(updateImagesError(error));
    }
  };
}

export function uploadImage(data) {
  return async (dispatch, getState, sdk) => {
    dispatch(uploadImageRequest(data));
    try {
      const response = await sdk.images.upload(data, {
        expand: true,
      });
      dispatch(uploadImageSuccess(response));
      return response.data;
    } catch (e) {
      const error = storableError(e);
      dispatch(uploadImageError(error));
    }
  };
}
